import React, { Component } from 'react';

import Modal from '../../Modal/Modal';
import './ReserveMessage.scss';

export const RESERVE_MESSAGE_MODAL_NAME = 'reserveMessage';

export class ReserveMessage extends Component {
    render = () => {
        return (
            <Modal className="modal_container" uniqueModalName={RESERVE_MESSAGE_MODAL_NAME} title="Notification">
                <div className="emvio-reserve-message-modal">
                    <p className="reserve-message">
                        Nexio recently identified a database issue that caused reserve balances displayed on this
                        page to be incorrect. Corrections will be finalized by the end of October 2026. No action is
                        required on your part. If you notice a change to your reserve balance and have questions,
                        please contact Nexio Customer Support at 801-623-4000, Monday through Friday, 7:00 AM–6:00 PM
                        Mountain Time.
                    </p>
                </div>
            </Modal>
        );
    };
}

export default ReserveMessage;
